var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "oops_icon",
    transform: "translate(2364 136.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_263",
    transform: "translate(-2364 -136.824)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#50ae2f",
    transform: "translate(0 .324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-lock",
    d: "M13.75 6.734h-.5v-1a2.5 2.5 0 0 0-5 0v1h-.5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1zm-3 4.55a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm1.55-4.55H9.2v-1a1.55 1.55 0 0 1 3.1 0z",
    className: "cls-2",
    transform: "translate(-.75 1.09)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Component_267",
    transform: "translate(-2364.112 -136.937)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-2",
    cx: 10,
    cy: 10,
    r: 10,
    className: "cls-2",
    transform: "translate(.112 .437)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "exclamation",
    fill: "#e86361",
    d: "M16 7.434a1.377 1.377 0 1 0 1.377-1.377A1.378 1.378 0 0 0 16 7.434zm2.594-7l-.234 4.68a.413.413 0 0 1-.412.392h-1.142a.413.413 0 0 1-.412-.392l-.235-4.68A.413.413 0 0 1 16.572 0h1.61a.413.413 0 0 1 .412.434z",
    transform: "translate(-7.418 5.718)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b0b8d59fa3955a40dde4266e46a998c2.svg";
export { ForwardRef as ReactComponent };